module.exports = __webpack_public_path__ + "img/chat-bg.190064f4.png";